/**
 * How far the promotion of a produced Nutzdatendatei into the WORM archive got
 * (TM-9634 / #1606, ADR-0035).
 *
 * - `ARCHIVED` — the bytes lie locked in the archive, read back and confirmed by
 *   hash. From here the archived copy is the authoritative one, and the non-WORM
 *   copy has been removed.
 * - `FAILED` — the promotion step failed. The bytes still lie in the non-WORM
 *   tier; the billing run is untouched by it.
 *
 * ⚠ **No `PENDING`.** A file nobody has worked on yet carries no archive record
 * at all — `null` says that without inventing a state no step ever writes. A
 * `PENDING` would have to be set at `markProduced`, that is inside the file's
 * transaction, and would claim a promotion there that may only begin after its
 * commit.
 */
export var GkvNutzdatenArchiveStatus;
(function (GkvNutzdatenArchiveStatus) {
    GkvNutzdatenArchiveStatus["ARCHIVED"] = "ARCHIVED";
    GkvNutzdatenArchiveStatus["FAILED"] = "FAILED";
})(GkvNutzdatenArchiveStatus || (GkvNutzdatenArchiveStatus = {}));
//# sourceMappingURL=gkv-nutzdaten-archive-status.enum.js.map